import React from 'react';
import { cnDivider } from '../Divider';
export var DividerLine = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 1 : _b, color = _a.color;
    return (React.createElement("span", { className: cnDivider('Line'), style: { height: size > 0 ? size : 1, backgroundColor: color } }));
};
